<template>
  <div>
    <el-row v-for="(chart, index) in $root.unusedChartTelList" :key="index">
      <div @click="OnRemove(chart.name)">
        <el-card shadow="always">
          {{ chart.displayName }}
        </el-card>
      </div>
    </el-row>
   
  </div>
</template>

<script>
export default {
  name: "RealTimeTelSettingMenu",
  methods: {
    OnRemove(title) {
      let list = this.$root.unusedChartTelList;
      for (let index in list) {
        if (list[index].name === title) {
          this.$root.usedChartTelList.push(
            this.$root.unusedChartTelList[index]
          );
          this.$root.unusedChartTelList.splice(index, 1);
        }
      }
      localStorage.setItem('usedChartTelList', JSON.stringify(this.$root.usedChartTelList))
      if (this.$root.usedChartTelList.length <= 5) {
        this.$root.barscrollFlg = "false";
      } else {
        this.$root.barscrollFlg = "true";
      }
      
    },
  },
};
</script>


<style>
</style>
